import * as React from 'react';
type Props = {
  className?: string;
};
export function Immunity({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Immunity"
      className={className}
    >
      <path
        d="M20.1491 38.13L17.6891 36.39C9.41905 30.55 4.65905 20.93 5.01905 10.81L5.08906 8.78L5.80905 8.71C11.2491 8.21 16.3291 5.79 20.1491 1.88L21.1691 2.81C24.8691 6.19 29.5691 8.26001 34.5591 8.72001L35.2091 8.78L35.2791 10.92C35.6291 21.23 30.6591 31 22.1291 36.79L20.1491 38.13Z"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M28.0991 17V22.44H22.9391V27.59H17.4991V22.44H12.3391V17H17.4991V11.84H22.9391V17H28.0991Z"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
    </svg>
  );
}
